import commonDataAccess from "../commonDataAccess";

export interface ProductCriteriaSettingViewModel {
  Key: string;
  IsShow: boolean;
  IsAcceptanceCriteria: boolean;
}

class ProductCriteriaDataAccess {
  getProductCriteriaSettings(productId: number | string) {
    return commonDataAccess.getData("ProductCriteria/get/criteria-settings", {
      productId: productId,
    });
  }

  saveProductCriteriaSettings(
    productId: number | string,
    productCriteriaSettings: ProductCriteriaSettingViewModel[],
  ) {
    return commonDataAccess.postData(
      "ProductCriteria/save/criteria-settings",
      productCriteriaSettings,
      {
        productId: productId,
      },
    );
  }
}

export default new ProductCriteriaDataAccess();
